/**
 * Parse a date string safely, returning null if invalid
 * @param dateString - The date string to parse
 * @returns Parsed Date object or null if invalid
 */
export function parseDate(dateString: string): Date | null {
  try {
    const date = new Date(dateString)
    return Number.isNaN(date.getTime()) ? null : date
  } catch {
    return null
  }
}

/**
 * Format a date to a human-readable string
 * @param date - The date to format (Date object or string)
 * @returns Formatted date string (e.g., "October 20, 2025")
 */
export function formatDate(date: Date | string): string {
  // Parse string to Date if needed
  const dateObj = typeof date === 'string' ? parseDate(date) : date

  // Validate date
  if (!dateObj || Number.isNaN(dateObj.getTime())) {
    return 'Invalid Date'
  }

  return dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
